import { animateCampaign } from "../Campaign/campaign-animation";

const blocks = document.querySelectorAll<HTMLElement>(
  "[id^='data-campaign-booking-pre-selected']"
);

animateCampaign(blocks);
